import { Form, FormGroup, Input, Button } from "reactstrap";
import "../../App.css";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
// import MyLoader from "../util/loader";
import Picker from "../Picker";
import Api from "../api/api";
import classes from "./CodeForm.module.css";

const CodeForm = ({ onSubmit, data, editMode }) => {
  const [user, setUser] = useState(data?.owner_id);
  const [users, setUsers] = useState([]);
  const [code, setCode] = useState(data?.code ?? "");
  const [selectFromDatabase, setSelectFromDatabase] = useState(!!data?.user);
  const [name, setName] = useState(data?.name ?? "");
  const [email, setEmail] = useState(data?.email ?? "");

  useEffect(() => {
    Api.getUsers(1, (data) => {
      setUsers(data.data);
    });
  }, []);

  const handleSubmit = () => {
    onSubmit({
      id: editMode ? data.id : undefined,
      owner_id: selectFromDatabase ? user : undefined,
      code: code.toUpperCase(),
      email: selectFromDatabase ? undefined : email,
      name: selectFromDatabase ? undefined : name,
    });
  };

  return (
    <div className="main">
      <div className={"titlebar " + classes.titleBar}>
        <div style={{ color: "blue" }}>
          {/* {editMode ? "Edit" : "Add"} Category */}
        </div>
      </div>
      <div className={classes.container}>
        <Form className="form" style={{ width: 500, marginTop: 20 }}>
          <FormGroup>
            <Input
              disabled={!!editMode}
              type="text"
              placeholder="Code"
              value={code}
              onChange={(event) => {
                setCode(event.target.value);
              }}
            />
          </FormGroup>

          <FormGroup className={classes.checkboxSection}>
            <div className={classes.checkboxContainer}>
              <Input
                type="checkbox"
                checked={selectFromDatabase}
                onClick={() => setSelectFromDatabase(true)}
              />
              Select a user from database
            </div>
            <div className={classes.checkboxContainer}>
              <Input
                type="checkbox"
                checked={!selectFromDatabase}
                onClick={() => setSelectFromDatabase(false)}
              />
              Enter a user manually
            </div>
          </FormGroup>

          <FormGroup className={classes.formGroup}>
            {selectFromDatabase && (
              <Picker
                title="Select User"
                button={
                  <div type="button" className={classes.pickerButton}>
                    <div className={classes.pickerInnerContainer}>
                      {user && users.length
                        ? users.find((u) => u.id == user)?.email
                        : "Choose user"}
                    </div>
                  </div>
                }
                items={users.map((u) => ({ id: u.id, title: u.email }))}
                onSubmit={(selected) => setUser(selected)}
              />
            )}
            {!selectFromDatabase && (
              <>
                <Input
                  placeholder="Name"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
                <Input
                  placeholder="Email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </>
            )}
          </FormGroup>

          <Button
            style={{ marginTop: 20, fontSize: 16 }}
            className="btn-block btn-dark"
            onClick={() => {
              handleSubmit();
            }}
          >
            {editMode ? "Edit" : "Add"} Code
          </Button>
        </Form>
      </div>
      {/* <MyLoader loader={loader} /> */}
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default CodeForm;
